export function shortName(name: string | undefined | null) {
	if (!name) {
		return "";
	}

	const splitedName = name.split(" ");

	return `${splitedName[0]} ${splitedName.slice(-1)}`.toLowerCase();
}
